import React, { useContext, useEffect, useState } from 'react';
import { Checkbox, Notifier, notify } from '@scholastic/volume-react';

import { ProductsCheckbox, parseProducts } from '../../../utils/dataparsers.util';
import StepDescription from '../../Home/StepDescription/StepDescription';

import { 
    getCustomerInfoFromAPIResponse, 
    getProductsFromAPIResponse, 
    ProductsAPIResponse,  
 } from '../../Home/Home.dataparser';

import { fetchProductInfo } from '../../../state/Home.api';
import { StoreContext } from '../../../state/store';

import './GroupProductSelector.scss';

export interface GroupProductSelectorProps {
    callback(products: Array<ProductsCheckbox> | null): void;
}

const GroupProductSelector = ({callback}: GroupProductSelectorProps) => {
    const { state } = useContext(StoreContext);
    const customer = state.customerInfo;

    let parsedProductsView: any = [];
    const [products, setProducts] = useState<ProductsAPIResponse | null>(null);
  
    const [parsedProducts, setParsedProducts] = useState<Array<ProductsCheckbox>>([]);

    const getProducts = async (): Promise<void> => {
        try {
            const productsInfo: ProductsAPIResponse = await fetchProductInfo();
            setProducts(productsInfo);
        } catch(err) {
            notify.warning("Something went wrong, please try again later");
            console.error(err);
        }
    };

    useEffect(() => {
        getProducts();
    }, []);

    useEffect(() => {
        if(products && customer) {
            const rawProducts: { [key: string]: string } | null = getProductsFromAPIResponse(products);
            const customerProducts: Array<string> | undefined = getCustomerInfoFromAPIResponse(customer)
              ?.products;
            const goProducts: Array<string> | undefined =  getCustomerInfoFromAPIResponse(customer)?.goproducts;
            setParsedProducts(parseProducts(customerProducts, rawProducts).concat(parseProducts(goProducts, rawProducts)));
        }
    }, [customer, products]);

    useEffect(() => {
        callback(parsedProducts);
    }, [parsedProducts, callback])

    if (parsedProducts) {
        parsedProductsView = parsedProducts.map((product: ProductsCheckbox) => {
            return (
                <div className="stats-site-selector__check-box-holder" key={product.value}>
                    <span className="stats-site-selector__check-box-label">
                        <Checkbox checked={product.checked} onInputChange={(e, isChecked) => {
                            setParsedProducts((prevState) => {
                                return prevState.map(item => {
                                    if(item.value === product.value) {
                                        item.checked = !isChecked;
                                    }
                                    return item;
                                })
                            })
                        }} />
                    </span>
                    <span className="stats-site-selector__check-box-label">{product.label}</span>
                </div>
            );
        });
    }

    return (
        <div className="stats-glr">
            <Notifier
                autoClose={5000}
                closeButton={false}
                closeOnClick={false}
                draggable
                draggablePercent={50}
                limit={1}
                newestOnTop
                pauseOnFocusLoss
                pauseOnHover
                position="top-center"
                role="alert"
            />

            <StepDescription order="1" description="Select the product for which you wish to view stats data:"/>
            { parsedProductsView }
        </div>
    );
}

export default GroupProductSelector;